/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetLoginFeatureFlagsRequest} from '@cash-web/protos/squareup/cash/semaphore/api/SemaphoreCustomerCircumstance.pb'
import {GetLoginFeatureFlagsResponse} from '@cash-web/protos/squareup/cash/semaphore/api/SemaphoreCustomerCircumstance.pb'


export const getLoginFeatureFlags = (request: GetLoginFeatureFlagsRequest, options?: CashRequestOptions) => post<GetLoginFeatureFlagsRequest, GetLoginFeatureFlagsResponse>("/2.0/cash/get-login-feature-flags", request, {...options, rejectOnError: true })